"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAudioSegmentationParameters = void 0;
exports.UserAudioSegmentationParameters = [
    {
        id: 'recording',
        label: 'Recording File',
        description: 'Input Param - Recording file to be segmented',
        type: 'string',
        paramType: 'FILE',
        required: true,
    },
    {
        id: 'min',
        label: 'Minimum Markers',
        description: 'Input Param - Minimum number of markers required',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'max',
        label: 'Maximum Markers',
        description: 'Input Param - Maximum number of markers required',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'min_segment_length',
        label: 'Minimum Segment Length',
        description: 'Input Param - Minimum length of a segment in milliseconds',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'max_segment_length',
        label: 'Maximum Segment Length',
        description: 'Input Param - Maximum length of a segment in milliseconds',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'initial_segments',
        label: 'Initial Segments',
        description: 'Input Param - Initial segments to start with',
        type: 'json_array',
        paramType: 'ARRAY',
        required: false,
    },
    {
        id: 'show_amplitudes',
        label: 'Show Amplitudes',
        description: 'Input Param - Whether to show amplitudes in the history',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'segments',
        label: 'Segments',
        description: 'Output Param - List of objects containing the start and end timestamps of the segment in milliseconds',
        type: 'output',
        paramType: 'ARRAY',
        required: true,
    },
    {
        id: 'enable_adjustments',
        label: 'Enable Adjustments',
        description: 'Input Param - Enable fine-tune adjustment of segments',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
];
//# sourceMappingURL=UserAudioSegmentationComponent.js.map